/**
 * The header toggles' shared look, overriding shadcn's default (transparent
 * off, `accent` on): on the bootstrap theme `accent` is a barely-tinted
 * neutral surface, so a pressed guide/bleed/3D button was almost
 * indistinguishable from an unpressed one. Off stays bare (no fill, no
 * border) and on is `primary`, the site's brand color, which no other header
 * state uses — so the difference is the fill alone.
 *
 * Shared by {@link ToggleButton} and the segmented `PageGroupingControl` so
 * both read as one control family.
 */
export const TOGGLE_BUTTON_CLASS =
  "bg-transparent hover:bg-accent hover:text-accent-foreground " +
  "data-[state=on]:bg-primary data-[state=on]:text-primary-foreground " +
  "data-[state=on]:hover:bg-primary/90 data-[state=on]:hover:text-primary-foreground"

/**
 * Same idea for the sidebar rail's open-panel button, which shadcn lights with
 * `sidebar-accent` — the same near-invisible neutral. Only the active state is
 * repainted: the rail is a column of bare icons, not a row of chips, so an
 * idle button stays transparent.
 */
export const SIDEBAR_ACTIVE_CLASS =
  "data-[active=true]:bg-primary data-[active=true]:text-primary-foreground " +
  "data-[active=true]:hover:bg-primary/90 data-[active=true]:hover:text-primary-foreground"
